// shared site chrome -> dist/js/chrome.min.js
//
// The v3 header/nav interactions, loaded on every front-end page so the one
// header behaves the same everywhere. Moved out of the per-page bundles
// (home.js / who-we-are.js) so the nav logic lives in one place:
//   - scroll auto-hide + shadow (hide on scroll down past 150px, show on up)
//   - the "Our offerings" / "Resources" dropdown panels (hover + focus)
//   - the small-screen menu (hamburger toggle + close-on-link)
//   - the newsletter/subscribe forms' submit (every page shares the header,
//     so this file is also the natural single home for that, rather than
//     duplicating a submit handler per page bundle)
//
// Guards on [data-nav], so it is a no-op on any page with no header. The mobile
// state is owned here (the auto-hide leaves the bar in place while the menu is
// open), so the page bundles no longer touch the nav at all.

(function () {
  "use strict";

  var nav = document.querySelector("[data-nav]");
  if (!nav) return;

  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  var mobileOpen = false;

  // --- nav: scroll auto-hide + shadow -------------------------------------
  var lastY = 0;
  function handleScroll() {
    var y = Math.max(0, window.scrollY || 0);
    var down = y > lastY + 4, up = y < lastY - 4;
    if (!mobileOpen) {
      if (down && y > 150) {
        nav.style.transform = "translateY(-104%)";
        document.documentElement.setAttribute("data-nav-hidden", "1");
      } else if (up || y <= 150) {
        nav.style.transform = "translateY(0)";
        document.documentElement.setAttribute("data-nav-hidden", "0");
      }
    }
    nav.style.boxShadow = y > 8 ? "0 10px 30px rgba(18,63,68,.06)" : "none";
    if (down || up) lastY = y;
  }
  var raf = 0;
  window.addEventListener("scroll", function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; handleScroll(); });
  }, { passive: true });

  // --- nav dropdown panels ------------------------------------------------
  function setPanel(host, open) {
    var p = host.querySelector("[data-panel]");
    if (p) {
      p.style.opacity = open ? "1" : "0";
      p.style.visibility = open ? "visible" : "hidden";
      p.style.transform = open ? "translateY(0)" : "translateY(-8px)";
    }
    var c = host.querySelector("[data-caret]");
    if (c) c.style.transform = open ? "rotate(45deg)" : "rotate(0deg)";
  }
  $$("[data-menu]").forEach(function (m) {
    m.addEventListener("mouseenter", function () { setPanel(m, true); });
    m.addEventListener("mouseleave", function () { setPanel(m, false); });
    m.addEventListener("focusin", function () { setPanel(m, true); });
    m.addEventListener("focusout", function () { setPanel(m, false); });
  });

  // --- small-screen menu --------------------------------------------------
  var mToggle = document.querySelector("[data-mobile-toggle]");
  var mMenu = document.querySelector("[data-mobile-menu]");
  if (mToggle && mMenu) {
    mToggle.addEventListener("click", function () {
      mobileOpen = mMenu.style.display !== "block";
      mMenu.style.display = mobileOpen ? "block" : "none";
      mToggle.setAttribute("aria-expanded", mobileOpen ? "true" : "false");
    });
    $$("[data-mobile-close]", mMenu).forEach(function (a) {
      a.addEventListener("click", function () {
        mobileOpen = false;
        mMenu.style.display = "none";
        mToggle.setAttribute("aria-expanded", "false");
      });
    });
  }

  // --- newsletter: POST the subscribe forms --------------------------------
  // Every subscribe form on the site shares the same markup shape: a
  // <form data-nl-form> with name/email inputs and a <span data-nl-cta> that
  // carries the button label. This used to be a client-side no-op (the CTA
  // just flipped to "Subscribed" with nothing sent); now it actually posts to
  // the pe_v2_newsletter_subscribe ajax action (registered in
  // inc/pe-v2-newsletter.php, which also localizes window.peV2Newsletter with
  // the ajax URL + nonce). The visual success state is unchanged — the CTA
  // still just becomes "Subscribed", now only once the request has actually
  // succeeded.
  var nlCfg = window.peV2Newsletter || {};
  $$("[data-nl-form]").forEach(function (form) {
    var sending = false;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (sending || !nlCfg.ajaxUrl) return;

      var nameEl = form.querySelector("input[name='name']");
      var emailEl = form.querySelector("input[name='email']");
      var name = nameEl ? nameEl.value.trim() : "";
      var email = emailEl ? emailEl.value.trim() : "";
      if (!name || !email) return;

      sending = true;
      var fd = new FormData();
      fd.append("action", "pe_v2_newsletter_subscribe");
      fd.append("nonce", nlCfg.nonce || "");
      fd.append("name", name);
      fd.append("email", email);
      fd.append("page", window.location.pathname);

      fetch(nlCfg.ajaxUrl, { method: "POST", body: fd })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          sending = false;
          if (data && data.success) {
            // Replace the whole form with a success note. Inherits the
            // surrounding text colour, so it reads on both the light (home /
            // listing) and dark (who-we-are / reader) newsletter sections.
            form.innerHTML =
              '<p role="status" data-nl-done="1" style="margin:0;font-size:clamp(15px,1.05vw,18px);' +
              'line-height:1.5;letter-spacing:-.008em;font-weight:500;">' +
              'You are now subscribed to our Field Notes.</p>';
          }
        })
        .catch(function () { sending = false; });
    });
  });
})();
